import { jsx as we } from "react/jsx-runtime";
import { forwardRef as Pe, useMemo as D, useState as w, useRef as K, Children as ge, useCallback as be, useEffect as x, useImperativeHandle as Re } from "react";
import { u as Se } from "../../../chunks/index.ByijsZJJ.js";
import { s as Q, createCardSections as De, findNextCard as Z, animateCarousel as xe, findPrevCard as ee, findCurrentSection as $e, findFinalCard as Me, initCardWidths as Te, clearCurrentTimeout as $, updateResponsiveSettings as Be, dragMoveCarousel as ze } from "./DCarouselHelpers.js";
const Fe = /* @__PURE__ */ Pe(
  ({
    carouselClassname: z,
    settings: O,
    responsiveSettings: E,
    setCarouselInternal: X,
    hideOverflow: te = !0,
    children: H,
    dataQA: ve
  }, Ie) => {
    E = D(
      () => E?.filter((e) => e.breakpoint && e.breakpoint > 0).sort((e, t) => e.breakpoint - t.breakpoint),
      [E]
    );
    const [o, W] = w(0), [ne, ye] = w(window.innerWidth), [k, Le] = w({
      ...O,
      ...E?.find((e) => window.innerWidth < e.breakpoint)?.settings || {}
    }), [re, j] = w(!1), [F, I] = w([]), [h, J] = w(!1), [Ae, U] = w(!1), y = K(null), g = K(null), v = K([]), {
      cardsPerSection: c = 1,
      gapBetweenCards: oe = "1rem",
      cardsToScroll: u = 1,
      animationDuration: R = 500,
      autoplaySettings: N,
      prettyWrapping: l = !0,
      draggable: se = !1,
      animationEasing: ie = "ease-in"
    } = k, i = k.wraps && ge.toArray(H).length > c || !1, { autoplayDirection: ae, intervalDuration: ce } = N || {}, Ee = D(
      () => `${Q.dCarousel}${z ? ` ${z}` : ""}`,
      [z]
    ), We = D(
      () => `${Q.dCarouselContainer}${te ? ` ${Q.dCarouselContainerOverflowHidden}` : ""}`,
      [te]
    ), {
      totalSections: L,
      sectionIndexes: ue,
      beginningIndex: n,
      sections: Y,
      endingIndex: d,
      cellIndexes: b,
      totalCells: le
    } = D(() => De(
      i,
      ge.toArray(H),
      c,
      v
    ), [c, H, i]), P = D(
      () => ({
        easing: ie,
        fill: "forwards",
        duration: R
      }),
      [R, ie]
    ), M = be(() => {
      W((e) => {
        const t = Z(
          u,
          c,
          e,
          d,
          n,
          i,
          l,
          b
        );
        return e === t || xe(
          "next",
          v,
          g,
          y,
          t,
          i,
          P,
          d,
          n
        ), t;
      });
    }, [
      l,
      i,
      P,
      u,
      c,
      n,
      d,
      b
    ]), T = be(() => {
      W((e) => {
        const t = ee(
          u,
          c,
          e,
          d,
          n,
          i,
          l
        );
        return e === t || xe(
          "previous",
          v,
          g,
          y,
          t,
          i,
          P,
          d,
          n
        ), t;
      });
    }, [
      P,
      n,
      u,
      c,
      d,
      l,
      i
    ]);
    x(() => {
      if (o - n >= 0 && X) {
        const e = JSON.parse(ue), t = JSON.parse(b), f = $e(
          i,
          l,
          c,
          o,
          n,
          d,
          L,
          e
        ), s = o - n;
        let r = Object.keys(e).length;
        const m = Me(l, b, d, c) - (i && !l ? n : 0);
        let p = l ? Math.ceil(m / u) : Math.floor(m / u);
        m % u === 0 && !l && i && p--;
        const C = l && o === le - c ? p : Math.ceil((o - n) / u);
        X({
          cardIndex: s,
          sectionIndexes: e,
          currentSection: f,
          totalSections: L,
          totalCards: r,
          clickNumber: C,
          clicksToEnd: p,
          atCarouselBeginning: !i && o === 0,
          atCarouselEnd: L === 0 || !i && f === L,
          cellIndexes: t,
          currentSettings: k
        });
      }
    }, [
      n,
      o,
      L,
      X,
      d,
      ue,
      l,
      i,
      c,
      u,
      le,
      b,
      k
    ]), x(() => {
      Te(y, g, c, oe, Y);
    }, [oe, c, Y]), x(() => {
      if (o >= n)
        return j(!0), () => {
          j(!1);
        };
      W(n);
      const e = g.current, t = v.current;
      return e && t.length > 0 && e.animate(
        [{ transform: `translate3d(${-(t[n].offsetLeft - 1)}px, 0, 0)` }],
        {
          duration: 0,
          fill: "forwards"
        }
      ), () => {
        j(!1);
      };
    }, [n, o]);
    const [q, ke] = w(), [B, de] = w(!1);
    x(() => {
      const e = () => {
        const t = window.innerWidth;
        ye(t), J(!1), U(!1), ne !== t && (Be(
          E,
          t,
          O,
          Le,
          de
        ), $(I), ke(o - n));
      };
      return h || e(), window.addEventListener("resize", e), () => {
        window.removeEventListener("resize", e);
      };
    }, [E, o, O, ne, n, h]), x(() => {
      B && q !== void 0 && (W((e) => {
        const t = q + n, f = t % u, s = t - f;
        let r = Z(
          u,
          c,
          s,
          d,
          n,
          i,
          l,
          b
        );
        s + u <= d && s !== r && (r = ee(
          u,
          c,
          r,
          d,
          n,
          i,
          l
        ));
        const m = g.current, p = v.current;
        return m && p.length > 0 && (m.getAnimations().forEach((a) => a.cancel()), m.animate(
          { transform: `translate3d(${-(p[r]?.offsetLeft - 1) || 0}px, 0, 0)` },
          { fill: "forwards", duration: 0 }
        )), r;
      }), de(!1));
    }, [
      c,
      q,
      u,
      n,
      B,
      l,
      i,
      d,
      b
    ]), x(() => {
      if (!(!re || o === void 0 || !k)) {
        if (!N || N && !Object.keys(N).length || h) {
          $(I);
          return;
        }
        if (F.length === 0 && N && !h) {
          const e = ce || 3e3;
          let f = (ae || "forwards") !== "backwards" ? M : T;
          const s = () => {
            f();
            const r = setTimeout(s, e + R);
            I((m) => (m.forEach((a) => clearTimeout(a)), [r]));
          };
          if (F.length === 0) {
            const r = setTimeout(s, e + R);
            I([r]);
          }
        }
      }
    }, [
      k,
      ae,
      N,
      F,
      M,
      T,
      R,
      ce,
      h,
      re,
      o
    ]);
    const { width: G } = Se({
      ref: y,
      box: "content-box"
    }), [fe, Ne] = w();
    return x(() => {
      if (G !== fe && !h) {
        const e = g.current, t = v.current;
        e && t.length > 0 && (e.getAnimations().forEach((f) => f.cancel()), e.animate(
          { transform: `translate3d(${-(t[o]?.offsetLeft - 1 || 0)}px, 0, 0)` },
          { fill: "forwards", duration: 0 }
        ));
      }
      Ne(G);
    }, [o, h, G, fe]), x(() => {
      const e = g.current;
      let t = v.current;
      if (e || B) {
        let f = 0;
        const s = Number(
          y.current?.style.getPropertyValue("--d-carousel-cards-per-sections")
        ) || 1;
        t.forEach((r, m) => {
          r && (r.classList.remove("visible"), r.setAttribute("aria-current", "false"), r.setAttribute("aria-hidden", "true"), r.setAttribute("inert", ""), m >= o && f < s && (f = Number(r.getAttribute("data-custom-span")) + f, r.classList.add("visible"), r.setAttribute("aria-current", "true"), r.setAttribute("aria-hidden", "false"), r.removeAttribute("inert")));
        });
      }
    }, [o, B]), x(() => {
      if (!se || L < 1 || o < n) return;
      const e = g.current, t = y.current, f = v.current;
      if (f.length > 0 && t && e) {
        let s;
        const r = (a) => {
          a.stopPropagation(), J(!0), h || (s = "touches" in a ? a.touches[0].clientX : a.x);
        }, m = (a) => {
          if (a.stopPropagation(), h) {
            let C = "touches" in a ? a.touches[0].clientX : a.x;
            const me = "touches" in a ? a.touches[0].clientY : a.y;
            if (s === C) return;
            if (!s) {
              s = C;
              return;
            }
            const pe = t.getBoundingClientRect();
            if (pe.bottom < me || pe.top > me)
              return p(a);
            $(I);
            const V = e.getBoundingClientRect().left - t.getBoundingClientRect().left - e.offsetLeft;
            e.getAnimations().forEach((A) => A.cancel());
            const he = t.clientWidth / 4, Ce = f[o];
            let _;
            -(Ce.offsetLeft + he) > V - (s - C) && C < s ? W((A) => {
              const S = Z(
                u,
                c,
                A,
                d,
                n,
                i,
                l,
                b
              );
              return S < A && (_ = "forwards"), S;
            }) : (
              // if pointer interaction is sliding the carousel backwards
              -(Ce.offsetLeft - he) <= V - (s - C) && C > s && W((A) => {
                const S = ee(
                  u,
                  c,
                  A,
                  d,
                  n,
                  i,
                  l
                );
                return S > A && (_ = "backwards"), S;
              })
            ), ze(
              _,
              f,
              n,
              V,
              e,
              d,
              s,
              C
            ), U(!0), s = C;
          }
        }, p = (a) => {
          a.stopPropagation(), h && e.animate(
            { transform: `translate3d(${-(f[o]?.offsetLeft - 1) || 0}px, 0, 0)` },
            { ...P, easing: "linear" }
          ), J(!1), U(!1);
        };
        return t.onmousedown = r, t.ontouchstart = r, t.ontouchend = p, t.ontouchcancel = p, t.ontouchmove = m, window.addEventListener("mousemove", m), window.addEventListener("mouseup", p), () => {
          window.removeEventListener("mousemove", m), window.removeEventListener("mouseup", p);
        };
      }
    }, [
      P,
      n,
      u,
      c,
      d,
      o,
      h,
      l,
      i,
      se,
      L,
      b
    ]), Re(
      Ie,
      () => ({
        previous() {
          $(I), T();
        },
        next() {
          $(I), M();
        }
      }),
      [M, T]
    ), /* @__PURE__ */ we(
      "div",
      {
        className: We,
        ref: y,
        "data-qa": ve,
        role: "region",
        "aria-label": "D-Carousel",
        children: /* @__PURE__ */ we(
          "div",
          {
            className: Ee,
            ref: g,
            style: { pointerEvents: Ae ? "none" : void 0 },
            children: Y
          }
        )
      }
    );
  }
);
export {
  Fe as default
};
//# sourceMappingURL=DCarousel.js.map
